import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectUrlIconLarge = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 49 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_13724_91568)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M6.84961 5C6.84961 2.79086 8.64047 1 10.8496 1H29.8496L43.6496 14.8V43C43.6496 45.2091 41.8587 47 39.6496 47H10.8496C8.64047 47 6.84961 45.2091 6.84961 43V5Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M10.8496 1.34961H29.7051L43.2998 14.9443V43C43.2998 45.0158 41.6653 46.6504 39.6494 46.6504H10.8496C8.83377 46.6504 7.19922 45.0158 7.19922 43V5C7.19922 2.98416 8.83377 1.34961 10.8496 1.34961Z",
				stroke: "#A4A7AE",
				strokeWidth: .7
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_13724_91568)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M29.8496 1L43.6496 14.8H33.8496C31.6405 14.8 29.8496 13.0091 29.8496 10.8V1Z",
				fill: "#FDFDFD"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M43.0459 14.5498H33.8496C31.7785 14.5498 30.0996 12.8709 30.0996 10.7998V1.60352L43.0459 14.5498Z",
				stroke: "#A4A7AE",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .25,
			y: 22,
			width: 12,
			height: 12,
			rx: 2,
			fill: "url(#paint0_linear_13724_91568)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .25,
			y: 22,
			width: 12,
			height: 12,
			rx: 2,
			stroke: "#5CAB73",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_13724_91568)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.384 31.0467C8.20255 30.7419 8.86515 30.1167 9.2192 29.3235C8.8096 29.397 8.3569 29.4556 7.87345 29.4963C7.7668 30.1003 7.5975 30.6311 7.384 31.0467ZM6.25 32C8.45915 32 10.25 30.2092 10.25 28C10.25 25.7909 8.45915 24 6.25 24C4.04086 24 2.25 25.7909 2.25 28C2.25 30.2092 4.04086 32 6.25 32ZM6.49173 31.2411C6.41192 31.247 6.33131 31.25 6.25 31.25C6.16869 31.25 6.08808 31.247 6.00827 31.2411C6.0066 31.2396 6.00492 31.2379 6.00324 31.2363C5.87075 31.1083 5.72289 30.8927 5.58516 30.5779C5.45797 30.2872 5.3499 29.9357 5.2705 29.5389C5.58802 29.5544 5.91552 29.5625 6.25 29.5625C6.58448 29.5625 6.91197 29.5544 7.2295 29.5389C7.1501 29.9357 7.04203 30.2872 6.91484 30.5779C6.77711 30.8927 6.62925 31.1083 6.49677 31.2363C6.49508 31.2379 6.4934 31.2396 6.49173 31.2411ZM7.95935 28.8612C8.50685 28.8105 9.0058 28.7362 9.4362 28.644C9.47805 28.4359 9.5 28.2205 9.5 28C9.5 27.7795 9.47805 27.5641 9.4362 27.356C9.0058 27.2638 8.50685 27.1895 7.95935 27.1388C7.98595 27.4162 8 27.7043 8 28C8 28.2957 7.98595 28.5838 7.95935 28.8612ZM7.32625 27.092C7.35785 27.3799 7.375 27.684 7.375 28C7.375 28.316 7.35785 28.6201 7.32625 28.908C6.98062 28.9273 6.62045 28.9375 6.25 28.9375C5.87954 28.9375 5.51938 28.9273 5.17374 28.908C5.14215 28.6201 5.125 28.316 5.125 28C5.125 27.684 5.14215 27.3799 5.17374 27.092C5.51938 27.0727 5.87954 27.0625 6.25 27.0625C6.62045 27.0625 6.98062 27.0727 7.32625 27.092ZM7.87345 26.5037C8.3569 26.5445 8.80955 26.603 9.2192 26.6765C8.86515 25.8833 8.20255 25.2581 7.384 24.9533C7.5975 25.3689 7.7668 25.8998 7.87345 26.5037ZM6.49173 24.7589C6.4934 24.7604 6.49508 24.7621 6.49677 24.7637C6.62925 24.8918 6.77711 25.1073 6.91484 25.4221C7.04203 25.7128 7.1501 26.0643 7.2295 26.4611C6.91197 26.4456 6.58448 26.4375 6.25 26.4375C5.91552 26.4375 5.58802 26.4456 5.2705 26.4611C5.34989 26.0643 5.45797 25.7128 5.58516 25.4221C5.72289 25.1073 5.87075 24.8918 6.00324 24.7637C6.00492 24.7621 6.0066 24.7604 6.00827 24.7589C6.08807 24.753 6.16869 24.75 6.25 24.75C6.33131 24.75 6.41192 24.753 6.49173 24.7589ZM5.11601 24.9533C4.29745 25.2581 3.63487 25.8833 3.28079 26.6765C3.69042 26.603 4.14309 26.5445 4.62654 26.5037C4.7332 25.8998 4.90248 25.3689 5.11601 24.9533ZM4.54066 27.1388C3.99316 27.1895 3.49418 27.2638 3.0638 27.356C3.02196 27.5641 3 27.7795 3 28C3 28.2205 3.02196 28.4359 3.0638 28.644C3.49418 28.7362 3.99316 28.8105 4.54066 28.8612C4.51403 28.5838 4.5 28.2957 4.5 28C4.5 27.7043 4.51403 27.4162 4.54066 27.1388ZM4.62654 29.4963C4.14309 29.4556 3.69042 29.397 3.28079 29.3235C3.63487 30.1167 4.29745 30.7419 5.11601 31.0467C4.90248 30.6311 4.7332 30.1003 4.62654 29.4963Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.2188 24.1562C18.2188 23.5004 18.7504 22.9688 19.4062 22.9688H20.2969V21.1875H19.4062C17.7667 21.1875 16.4375 22.5167 16.4375 24.1562V27.4747C16.4375 27.8971 16.2969 28.1573 16.1267 28.3161C15.9482 28.4827 15.6591 28.6094 15.25 28.6094V30.3906C15.6591 30.3906 15.9482 30.5173 16.1267 30.6839C16.2969 30.8427 16.4375 31.1029 16.4375 31.5253V34.8438C16.4375 36.4833 17.7667 37.8125 19.4062 37.8125H20.2969V36.0312H19.4062C18.7504 36.0312 18.2188 35.4996 18.2188 34.8438V31.5253C18.2188 30.7296 17.9562 30.0241 17.4611 29.5C17.9562 28.9758 18.2188 28.2704 18.2188 27.4747V24.1562ZM30.0938 21.1875H29.2031V22.9688H30.0938C30.7496 22.9688 31.2812 23.5004 31.2812 24.1562V27.4747C31.2812 28.2704 31.5439 28.9758 32.0391 29.5C31.5439 30.0242 31.2812 30.7296 31.2812 31.5253V34.8438C31.2812 35.4996 30.7496 36.0312 30.0938 36.0312H29.2031V37.8125H30.0938C31.7333 37.8125 33.0625 36.4833 33.0625 34.8438V31.5253C33.0625 31.1033 33.2031 30.843 33.3734 30.684C33.552 30.5173 33.841 30.3906 34.25 30.3906V28.6094C33.841 28.6094 33.552 28.4827 33.3734 28.316C33.2031 28.157 33.0625 27.8967 33.0625 27.4747V24.1562C33.0625 22.5166 31.7333 21.1875 30.0938 21.1875ZM25.6406 32.1719V31.2812H23.8594V32.1719V34.9608C23.8594 35.483 23.7048 35.9934 23.4152 36.4279L22.9212 37.1689L24.4033 38.157L24.8973 37.4159C25.382 36.6889 25.6406 35.8346 25.6406 34.9608V32.1719ZM24.75 28.3125C25.5698 28.3125 26.2344 27.6479 26.2344 26.8281C26.2344 26.0083 25.5698 25.3438 24.75 25.3438C23.9302 25.3438 23.2656 26.0083 23.2656 26.8281C23.2656 27.6479 23.9302 28.3125 24.75 28.3125Z",
			fill: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_13724_91568",
				x: 1.84961,
				y: 0,
				width: 46.7998,
				height: 56,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 2,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_13724_91568"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_13724_91568"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_13724_91568"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_13724_91568",
						result: "effect2_dropShadow_13724_91568"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_13724_91568",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_13724_91568",
				x: 27.8496,
				y: 0,
				width: 17.7998,
				height: 17.8,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_13724_91568"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_13724_91568",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_13724_91568",
				x1: 6.25,
				y1: 22,
				x2: 6.25,
				y2: 34,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#94E4AB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#76B488"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_13724_91568",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(2.25 24)"
				})
			})
		] })
	]
});
export default SvgConnectUrlIconLarge;
